import React from "react";
import SignupIMG from "../../assets/Images/AboutUs/SignupIMG.jpg"
import SignIn from "../pages/SignIn/SignIn";
const Form = (props) => {
  return (
    <>
      <div  className="form-container">
        <div className="form-content-left">
          <img className="form-img img-fluid mx-auto" src={SignupIMG} alt="spaceship" />
        </div>
        <SignIn />
      </div>
    </>
  );
};

export default Form;
